import { useRef, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import {
  checkSessionInterval,
  doExtendSession,
  fetchMemberProfile,
  handleFetchError,
  logout,
  saveCredentials,
  setPath,
} from './handlers'

const PROFILE_PATH = '/fpm/profile'
const INITIAL_NETWORK_ERROR = {
  error: false,
  message: null,
}

const useAuth = () => {
  const router = useRouter()
  const checkSessionExpiry = useRef()
  const connectionErrorPopup = useRef()
  const [refreshInterval, setRefreshInterval] = useState(new Date().getTime())
  const [isLoading, setIsLoading] = useState(true)
  const [hasNetworkError, setHasNetworkError] = useState(INITIAL_NETWORK_ERROR)
  const [memberProfile, setMemberProfile] = useState(null)
  const [sessionModal, setSessionModal] = useState({
    show: false,
    timeRemaining: null,
  })

  useEffect(() => {
    fetchMemberProfile()
      .then(setMemberProfile)
      .then(() => {
        setPath({
          router,
          profilePath: PROFILE_PATH,
          setIsLoading,
        })
      })
      .catch(error => {
        handleFetchError({
          error,
          router,
          profilePath: PROFILE_PATH,
          setIsLoading,
        })
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshInterval])

  useEffect(() => {
    checkSessionInterval({
      checkSessionExpiry,
      router,
      setSessionModal,
      sessionModal,
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => clearInterval(checkSessionExpiry.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshInterval, sessionModal])

  useEffect(() => {
    if (hasNetworkError) {
      connectionErrorPopup.current = setTimeout(() => {
        setHasNetworkError(INITIAL_NETWORK_ERROR)
      }, 10000)
    }

    return () => clearTimeout(connectionErrorPopup.current)
  }, [hasNetworkError])

  return {
    doExtendSession: () =>
      doExtendSession(() => {
        setRefreshInterval(new Date().getTime())
        setSessionModal({
          show: false,
          timeRemaining: null,
        })
      }),
    hasNetworkError,
    isLoading,
    isNewSession: router.query.session !== 'expired',
    logout: session => logout({ router, session }),
    memberProfile,
    redirectToProfile: () => router.push(PROFILE_PATH),
    saveCredentials,
    setHasNetworkError,
    sessionModal,
  }
}

export default useAuth
